module.exports = __webpack_public_path__ + "static/logo-b8e54eaca1a3c281070e933f3ed79dc3.svg";